import { FunctionComponent } from 'react';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Breakpoint } from '@mui/system';
import { GeneralDialogComponentProps } from 'models/GeneralDialogProps';

const initialState: GeneralDialogState = {
    open: false,
    dialogContent: null,
};

export const generalDialogSlice = createSlice({
    name: 'generalDialog',
    initialState,
    reducers: {
        setOpenDialog: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload;
        },
        setComponent: (state, action: PayloadAction<GeneralDialogContent>) => {
            state.dialogContent = action.payload;
        },
        setSize: (state, action: PayloadAction<Breakpoint>) => {
            state.dialogSize = action.payload;
        },
    },
});

export interface GeneralDialogState {
    open: boolean;
    dialogContent: GeneralDialogContent;
    dialogSize?: Breakpoint;
}

export interface GeneralDialogContent {
    title: string;
    confirmLabel?: string;
    closeLabel?: string;
    preSetContent?: any;
    onCloseWithSuccess?: () => void;
    component: FunctionComponent<GeneralDialogComponentProps>;
    hideActions?: boolean;
}

export const generalDialogAction = generalDialogSlice.actions;

export default generalDialogSlice.reducer;
